import { useRefDimensions } from '@hooks/use-ref-dimensions'
import React, { type FC, useRef } from 'react'

type Props = {
  url: string
  title: string
  className?: string
  id?: string
}

const Iframe: FC<Props> = ({ url, title, className, id }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const containerDimensions = useRefDimensions(iframeRef)

  return (
    <iframe
      ref={iframeRef}
      className={className}
      id={id}
      src={url}
      style={{ border: 'none' }}
      title={title}
      width="100%"
      height={
        containerDimensions?.width
          ? containerDimensions.width / (16 / 9)
          : 'auto'
      }
    />
  )
}

export default Iframe
